import { useState } from 'react';
import Button from 'components/CncUI/Button';
import useSnackbar from 'hooks/useSnackbar';

const DEFAULT_ERROR_MESSAGE = 'An error occurred';

const FeedbackButton = props => {
  const {
    children,
    onClick: upstreamOnClick,
    successMessage,
    errorMessage = DEFAULT_ERROR_MESSAGE,
    ...restOfProps
  } = props;

  const [isBusy, setIsBusy] = useState(false);
  const notify = useSnackbar();

  const getSnackbarSuccessMessage = result =>
    typeof successMessage === 'function'
      ? successMessage(result)
      : successMessage;

  const showSuccessNotification = result =>
    notify({
      type: 'success',
      message: getSnackbarSuccessMessage(result),
    });

  const getSnackbarErrorMessage = err =>
    typeof errorMessage === 'function' ? errorMessage(err) : errorMessage;

  const showErrorNotification = err =>
    notify({
      type: 'error',
      message: getSnackbarErrorMessage(err),
    });

  const onClick = (...args) => {
    try {
      const retVal = upstreamOnClick(...args);
      if (retVal && retVal.finally) {
        setIsBusy(true);
        retVal.finally(() => setIsBusy(false));
      }
      if (successMessage) {
        if (retVal && retVal.then) {
          retVal.then(showSuccessNotification);
        } else {
          showSuccessNotification(retVal);
        }
      }
      if (errorMessage && retVal && retVal.catch)
        retVal.catch(showErrorNotification);
      return retVal;
    } catch (err) {
      if (errorMessage) showErrorNotification(err);
    }
  };

  return (
    <Button
      {...restOfProps}
      onClick={upstreamOnClick && onClick}
      loading={isBusy}
    >
      {children}
    </Button>
  );
};

export { DEFAULT_ERROR_MESSAGE };
export default FeedbackButton;
